export default {
  install (Vue, options) {
    const $tools = {

      isMobile () {
        return window.innerWidth < 800
      },
      isTouchDevice () {
        return (('ontouchstart' in window) ||
             ('ontouchstart' in document.documentElement) ||
             (navigator.MaxTouchPoints > 0) ||
             (navigator.msMaxTouchPoints > 0))
      },
      getArray (el) {
        if (typeof (kf) === 'object') return [el]
        return el
      },
      getRelationShips (response, id) {
        const r = response.data.included.filter((o) => {
          return o.id === id
        })
        return r ? r[0] : null
      },
      getURL (path) {
        return '/' + path.langcode + path.alias
      },
      getProp (data, prop) {
        if (!data) return null
        prop = prop.split('.')
        let p = prop.shift()
        if (p) { return this.getProp(data[p], prop.join('.')) }
        return data || null
      }
    }

    Vue.prototype.$tools = $tools
    Vue.$tools = $tools
  }
}
